import { createAction } from 'redux-actions'

export const fetchSwimlanes = createAction('ORDERS-SWIMLANES-FETCH_SWIMLANES')
export const fetchSwimlanesSucceed = createAction(
  'ORDERS-SWIMLANES-FETCH_SWIMLANES_SUCCEED'
)
export const fetchSwimlanesFailed = createAction(
  'ORDERS-SWIMLANES-FETCH_SWIMLANES_FAILED'
)

export const fetchSwimlane = createAction('ORDERS-SWIMLANES-FETCH_SWIMLANE')
export const fetchSwimlaneSucceed = createAction(
  'ORDERS-SWIMLANES-FETCH_SWIMLANE_SUCCEED'
)
export const fetchSwimlaneFailed = createAction(
  'ORDERS-SWIMLANES-FETCH_SWIMLANE_FAILED'
)

export const resetViewToLazyLoader = createAction(
  'ORDERS-SWIMLANES-RESET_VIEW_TO_LAZY_LOADER'
)
